// Bundle model
export default function bundle(bundle, defaultIncludeVat, decimalSeparator) {
  const price = defaultIncludeVat
    ? bundle.price.full.total
    : bundle.price.full.base;

  const rebatedPrice =
    bundle.price.rebated &&
    (defaultIncludeVat
      ? bundle.price.rebated.total
      : bundle.price.rebated.base);

  return {
    price: price.toString().replace(".", decimalSeparator),
    rebatedPrice:
      rebatedPrice && rebatedPrice.toString().replace(".", decimalSeparator),
    hasRebate: price !== rebatedPrice,
    showRebatedPrice: !/^(0\.00|0,00|0|0,-)$/.test(bundle.rebatePriceOnly),
    available: bundle.price.renewalAvailable,
    rebateType: bundle.price.rebateType,
    domain: bundle.prefix,
    tlds: bundle.tlds,
  };
}

/*
  Example response for a domain:
  "bundles":
  [
    {
        "prefix": "adsasdfsd",
        "tlds": [
            ".dk",
            ".one"
        ],
        "price": {
            "full": {
                "base": 206.4,
                "vat": 51.6,
                "total": 258,
                "vatRate": 0.25
            },
            "rebated": {
                "base": 134.4,
                "vat": 33.6,
                "total": 168,
                "vatRate": 0.25
            },
            "rebateType": "OTHER",
            "renewalAvailable": true
        }
    },
    {
        "prefix": "adsasdfsd",
        "tlds": [
            ".com",
            ".online",
            ".one"
        ],
        "price": {
            "full": {
                "base": 661.6,
                "vat": 165.4,
                "total": 827,
                "vatRate": 0.25
            },
            "rebated": {
                "base": 183.12,
                "vat": 45.78,
                "total": 228.9,
                "vatRate": 0.25
            },
            "rebateType": "OTHER",
            "renewalAvailable": true
        }
    }
  ]


*/
